<template>
  <header class="header">
    <div class="header_top">
      <div class="header_topbox">
        <div class="header_top_column">
          <a href="https://mizeinc.co.kr" target="_blank">MIZE INC.</a>
        </div>
        <div class="header_top_column">
          <!-- Vue 데이터 바인딩해야 함 -->
          <span class="top_name">{{ username }} 님 </span>
          <router-link            
            to="/myinfo/view"
            @click="selectMyInfo()"
            >내 정보</router-link
          >
          <!-- 알림 아이콘 -->
          <div
            v-if="userType === 'M'"
            class="notification-container"
            ref="notificationContainer"
            @click="toggleNotification"
          >
            <span class="top_name">알림</span>
            <span class="notification-badge">
              {{ unreadCount }}
            </span>
          </div>
          <a href="#" @click.prevent="logout">로그아웃</a>
        </div>
        <!-- 알림 드롭다운 -->
        <div
          v-if="showNotifications"
          class="notification-dropdown"
          ref="notificationDropdown"
        >
          <ul v-if="notifications.length > 0">
            <li
              v-for="(notification, index) in notifications"
              :key="index"
              :class="{ 'disabled-notification': !notification.commentId }"
              @click="
                !notification.commentId
                  ? null
                  : handleNotificationClick(
                      notification.id,
                      notification.commentId,
                      notification.readId,
                      index,
                      notification.leftMenuName
                    )
              "
            >
              <div class="notification-item">
                <!-- 이미지 추가 -->
                <div>
                  <div class="notification-image">
                    <img
                      :src="
                        notification.userPhotoName
                          ? `https://mizecloud-partners.co.kr/employee_img/${notification.userPhotoName}`
                          : 'https://mizecloud-partners.co.kr/employee_img/default.png'
                      "
                    />
                  </div>
                  <div>
                    <div class="notification-content">
                      <span class="notification-user">
                        <span v-if="!notification.commentId">(삭제됨)</span>
                        {{ notification.userName }} 님이</span
                      >
                      <span>{{ notification.commentSubject }}</span>

                      <span>
                        {{
                          notification.parentId
                            ? "댓글에 댓글을 남겼습니다."
                            : "게시물에 댓글을 남겼습니다."
                        }}
                      </span>
                    </div>
                    <small>{{ notification.createdDtm }}</small>
                  </div>
                </div>
              </div>
              <button
                class="remove-btn"
                @click.stop="
                  handleNotificationAction(notification.readId, index)
                "
              >
                X
              </button>
            </li>
          </ul>
          <div v-else class="no-notifications">새로운 알림이 없습니다.</div>
          <router-link
            to="/alarmsnotices/list"
            class="view-all"
            @click="closeNotification"
            >+ 모두보기</router-link
          >
        </div>
      </div>
    </div>
    <nav class="header_bottom">
      <div class="header_bottombox">
        <!--이거 할때랑 스타일이 달라짐 체크해야 함-->
        <div class="logo">
          <img src="@/images/logo_w.png" @click="handleLogoClick" />
        </div>
        <div class="menu">
          <router-link
            v-for="(menu) in topMenus"
            :key="menu.topMenuId"
            :to="newTapMenu(menu) ? '' : getRoute(menu)"
            :class="{ on: $store.state.selectedMenuId === menu.topMenuId }"
            @click.prevent="goToMenu(menu)"
          >
            <img :src="getImageUrl(menu.menuImg)" alt="" />{{ menu.menuName }}
          </router-link>
          <router-link
            v-if="userModeAuthority === 'A' && userType === 'M'"
            to=''
            @click="changeMode()"
          >
            <img src="@/images/mode_w.png" alt="" />모드전환
          </router-link>
        </div>
      </div>
    </nav>
  </header>
</template>

<script>
import apiClient from "@/apiClient"; // 설정 파일에서 가져온 axios 인스턴스
import { useToast } from "vue-toastification";
import eventBus from '@/eventBus';

export default {
  data() {
    return {
      showNotifications: false, // 알림 드롭다운 표시 여부
      notifications: [], // 알림 데이터
      unreadCount: 0, // 읽지 않은 알림 개수
      alarmList: [], // 추가된 공지사항 데이터를 저장
      prevLeftMenus: []
    };
  },
  name: "MainHeader", // 다중 단어로 변경
  setup() {
    const toast = useToast();
    return { toast };
  },
  emits: ["menu-selected"], // 이벤트 정의 추가
  computed: {
    username() {
      return this.$store.getters.getUsername;
    },
    userType() {
      return this.$store.getters.getUsertype;
    },
    userModeAuthority() {
      return this.$store.getters.getUserModeAuthority;
    },
    selectedMenu() {
      return this.$store.getters.getSelectedMenu;
    },
    topMenus() {
      return Array.isArray(this.$store.state.topMenus) ? this.$store.state.topMenus : [];
    }
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleOutsideClick);
    eventBus.off("user-info-updated", this.getTopMenu);
    eventBus.off("user-info-updated", this.getLeftMenu);
  },
  async mounted() {
    this.checkAuth();
    this.fetchNotifications();
    const token_userid = localStorage.getItem("userid");

    if (token_userid) {
      const user = {
        UserId: token_userid,
      };

      // API 호출
      if (user.UserId) {
        try {
          const response = await apiClient.post("/api/User/user-my-info", user);

          if (response.status === 200) {
            const userName = response.data.user.AdminName;
            const usertype = response.data.user.UserType;
            const userModeAuthority = response.data.user.ModeAuthority;

            this.$store.dispatch("updateUserName", userName); // Vuex 스토어와 localStorage에 저장
            this.$store.dispatch("updateUserType", usertype); // Vuex 스토어와 localStorage에 저장
            this.$store.dispatch("updateUsermodeauthority", userModeAuthority); // Vuex 스토어와 localStorage에 저장
          }
        } catch (error) {
          console.error("Error fetching user data:", error);
        }
      }
    } else {
      this.$router.push({ path: "/" });
    }

    document.addEventListener("click", this.handleOutsideClick);

    if (this.$store.state.menuMode === '') {
      if (this.userModeAuthority === 'A')
        this.$store.state.menuMode = this.$store.state.menuMode === 'M' ? 'C' : 'M';
      else
        this.$store.state.menuMode = this.userType === 'M' ? 'M' : 'C';
    }

    eventBus.on("user-info-updated", this.getTopMenu);
    eventBus.on("user-info-updated", this.getLeftMenu);
    await this.getTopMenu(this.$store.state.menuMode);
  },
  methods: {
    handleNotificationClick(postId, commentId, readId, index, leftMenuName) {
      if (!postId) {
        console.error("Post ID가 없습니다.");
        return;
      }
      // 1. 읽음 처리
      this.handleNotificationAction(readId, index).then(() => {
        this.autoSetTopLeftMenu(leftMenuName);
        if (leftMenuName === "프로젝트목록 (마이즈)") {
          this.$router.push({
            path: `/projects/mizeview/${postId}`,
            query: { commentId },
          });
        }

        if (leftMenuName === "프로젝트목록 (외주)") {
          this.$router.push({
            path: `/projects/view/${postId}`,
            query: { commentId },
          });
        }

        if (leftMenuName === "담당자목록") {
          this.$router.push({
            path: `/managers/view/${postId}`,
            query: { commentId },
          });
        }

        if (leftMenuName === "직원목록") {
          this.$router.push({
            path: `/employee/view/${postId}`,
            query: { commentId },
          });
        }

        if (leftMenuName === "공지사항목록") {
          this.$router.push({
            path: `/notices/view/${postId}`,
            query: { commentId },
          });
        }

        // 3. 페이지 로드 후 스크롤 처리
        this.$nextTick(() => {
          setTimeout(() => {
            const commentElement = document.getElementById(
              `comment-${commentId}`
            );
            if (commentElement) {
              commentElement.scrollIntoView({ behavior: "smooth" });
            }
          }, 500);
        });
      });
    },
    getRoute(menu) {      
      if (menu.menuLink) {
        return '/' + menu.menuLink.replace(/^\/+/, '');
      }
      
      return '/';
    },
    getImageUrl(imgFileName) {
      try {
        return require(`@/images/${imgFileName}`)
      } catch (e) {
        console.error('이미지 로드 실패', imgFileName)
        return ''
      }
    },
    newTapMenu(menu) {
      return menu.menuName === 'CS' || menu.menuName === '방문객예약';
    },
    goToMenu(menu) {    
      if (this.newTapMenu(menu)) {
        const url = menu.menuDomain + menu.menuLink + localStorage.getItem("encryptUserid");
        window.open(url, '_blank');
        return;
      }
      if (menu.menuLink === '') {
        alert('준비중입니다.');
        this.$store.commit('setSelectedMenu', '공지사항');
        this.$store.commit('setSelectedMenuId', this.findTopMenuId(this.topMenus, 'M', '공지사항'));

        if (this.$store.state.menuMode === 'M')
          this.$router.push({ path: "/mizenotices/list" });
        
        return;
      }
      
      this.$store.commit('setSelectedMenu', menu.menuName);
      this.$store.commit('setSelectedMenuId', menu.topMenuId);
      
      if (menu.menuLink === this.$route.path) {
        const currentPath = this.$route.path;
        this.$store.commit('setRefreshFlag', true);

        this.$router.replace({ path: "/temp-route" }).then(() => {
          this.$router.replace(currentPath);
        });
      }
      else {
        this.$store.commit('setRefreshFlag', false);
        return this.$route.path
      }
    },
    async getTopMenu(menuMode = this.$store.state.menuMode) {
      if (this.$store.state.topMenus.length > 0) return;
      
      try {
          const user = {
            LoginUserId: localStorage.getItem("userid"),
            UserType: localStorage.getItem("usertype"),
            MenuMode: menuMode
          };

          const response = await apiClient.post("/api/Menu/top-menu-list", user);

          if (response.status === 200) {               
            this.$store.commit("setTopMenus", JSON.parse(response.data).data);
            this.setSelectedTopMenuByRoute();
            this.getLeftMenu();
          }
        } catch (error) {
          console.error("Error fetching top menu data:", error);
        }
    },
    async getLeftMenu() {   
      if (this.$store.state.leftMenus.length > 0) return;
 
      try {
          const user = {
            LoginUserId: localStorage.getItem("userid"),
            UserType: localStorage.getItem("usertype"),
            TopMenuId: this.$store.state.selectedMenuId,
            MenuMode: this.$store.state.menuMode
          };

          const response = await apiClient.post("/api/Menu/left-menu-list", user);

          if (response.status === 200) {            
            const originData =  JSON.parse(response.data).data;
            const addMyinfoData = {
              id: 0,
              topMenuId: 0,
              leftMenuId: 0,
              menuName: "내 정보 수정",
              menuDomain: "https://mizecloud-partners.co.kr",
              menuLink: "/myinfo/view"
            }
            const addNotiData = {
              id: 0,
              topMenuId: -1,
              leftMenuId: 0,
              menuName: "알림목록",
              menuDomain: "https://mizecloud-partners.co.kr",
              menuLink: "/alarmsnotices/list"
            }
            
            let mergedData = [...originData, addMyinfoData, addNotiData, ...this.prevLeftMenus];
            const filteredData = mergedData.filter(
              (item, index, self) =>
                index === self.findIndex((t) => t.menuLink === item.menuLink)
            );

            mergedData = filteredData;
            this.$store.commit("setLeftMenus", mergedData);   
          }
        } catch (error) {
          console.error("Error fetching left menu data:", error);
        }
    },
    async changeMode() {
      this.prevLeftMenus = [...this.$store.state.leftMenus];
      let menuMode = '';
      menuMode = this.$store.state.menuMode === 'M' ? 'C' : 'M';
      this.$store.commit('setMenuMode', menuMode);      
      this.$store.commit('setTopMenus', []); 
      this.$store.commit('setLeftMenus', []);
      await this.getTopMenu(menuMode);
    },
    async autoSetTopLeftMenu(leftMenuName) {
      this.$store.commit('setTopMenus', []);
      this.$store.commit('setLeftMenus', []);

      const keywordMap = [
        { keyword: '프로젝트', name: '프로젝트목록', changemode: 'C'},
        { keyword: '정산', name: '정산목록', changemode: 'C' },
        { keyword: '담당자', name: '담당자목록', changemode: 'C' },
        { keyword: '직원', name: '직원목록', changemode: 'M' },
        { keyword: '공지사항', name: '공지사항목록', changemode: 'C' }
      ];

      let matchedKeyword = keywordMap.find(item => leftMenuName.includes(item.name));
      let targetTopMenuId = null;
      let targetMenuName = null;

      this.$store.commit('setMenuMode', matchedKeyword.changemode);
      await this.getTopMenu(this.$store.state.menuMode);

      if (matchedKeyword) {
        const menu = this.$store.state.topMenus.find(m => m.menuName.includes(matchedKeyword.keyword));
        if (menu) {
          targetTopMenuId = menu.topMenuId;
          targetMenuName = menu.menuName;
        }
      }
      
      this.$store.commit('setSelectedMenu', targetMenuName);
      this.$store.commit('setSelectedMenuId', targetTopMenuId); 
    },
    setSelectedTopMenuByRoute() {
      const currentPath = this.$route.path;
      const matchedMenu = this.topMenus.find(menu => {
        return menu.menuLink && menu.menuLink === currentPath;
      });
      
      if (matchedMenu) {        
        this.$store.commit('setSelectedMenuId', matchedMenu.topMenuId);
      }
    },
    findTopMenuId(menuData, menuMode, menuName) {
      const matchedMenu = menuData.find(menu => {
        return menu.menuName === menuName && menu.menuMode === menuMode;
      });

      if (matchedMenu) {
        return matchedMenu.topMenuId;
      }
    },
    // 알림 읽음 및 제거 처리
    async handleNotificationAction(notificationId, index) {
      try {
        const searchParam = {
          Page: 1,
          PageSize: 5,
          SearchConfirmStatus: "N", // 미확인 알림만
          SearchStatus: "A", // 전체 카테고리
          SearchBoardStatus: "", // 게시판 전체
          SearchEmployeeStatus: "A", // 모든 직원
          LoginUserId: localStorage.getItem("userid"),
          SearchUserId: "All",
          ReadId: notificationId,
        };

        const response = await apiClient.post(
          "/api/Alarm/all-alarm-list",
          searchParam
        );
        console.log(`alarm response ==> ${JSON.stringify(response.data)}`)
        if (response.status === 200) {
          // 알림 배열에서 제거
          this.notifications.splice(index, 1);

          // 읽지 않은 알림 개수 감소
          this.unreadCount = Math.max(this.unreadCount - 1, 0);

          // 남은 알림이 5개 미만일 경우, 추가 데이터 가져오기
          if (
            this.notifications.length < 5 &&
            this.unreadCount > this.notifications.length
          ) {
            await this.fetchAdditionalNotifications(
              5 - this.notifications.length
            );
          }
        }
      } catch (error) {
        console.error(
          "Error marking notification as read and removing:",
          error
        );
      }
    },
    // 추가 알림 가져오기
    async fetchAdditionalNotifications(count) {
      try {
        const searchParam = {
          Page: Math.ceil((this.notifications.length + 1) / count), // 페이지 계산
          PageSize: count,
          SearchConfirmStatus: "N", // 미확인 알림만
          LoginUserId: localStorage.getItem("userid"),
          SearchUserId: "All",
        };

        const response = await apiClient.post(
          "/api/Alarm/all-alarm-list",
          searchParam
        );

        if (response.status === 200) {
          const data = JSON.parse(response.data);

          // 새로운 알림 추가
          const additionalNotifications = Array.isArray(data.data)
            ? data.data
            : [];
          this.notifications.push(...additionalNotifications);

          // unreadCount 동기화
          this.unreadCount = data.meta.totalCount || this.notifications.length;
        }
      } catch (error) {
        console.error("추가 알림 가져오는 중 오류 발생:", error);
      }
    },
    handleOutsideClick(event) {
      const notificationDropdown = this.$refs.notificationDropdown;
      const notificationContainer = this.$refs.notificationContainer;

      if (
        notificationDropdown &&
        !notificationDropdown.contains(event.target) &&
        notificationContainer &&
        !notificationContainer.contains(event.target)
      ) {
        this.closeNotification(); // 알림 드롭다운 닫기
      }
    },
    toggleNotification() {
      this.showNotifications = !this.showNotifications;
      if (this.showNotifications) {
        this.fetchNotifications(); // 알림 데이터를 가져옵니다.
      }
    },
    closeNotification() {
      this.showNotifications = false; // 드롭다운 닫기
      
      this.$store.commit('setSelectedMenu', '알림');
      this.$store.commit('setSelectedMenuId', -1);
    },
    async fetchNotifications() {
      try {
        // 기존 fetchData 메서드 호출
        const searchParam = {
          Page: 1,
          PageSize: 5, // 알림 목록에서 가져올 항목 수 제한
          SearchConfirmStatus: "N", // 미확인 알림만
          SearchStatus: "A", // 전체 카테고리
          SearchBoardStatus: "", // 게시판 전체
          SearchEmployeeStatus: "A", // 모든 직원
          LoginUserId: localStorage.getItem("userid"),
          SearchUserId: "All",
        };
        
        const response = await apiClient.post(
          "/api/Alarm/all-alarm-list",
          searchParam
        );

        if (response.status === 200) {
          const data = JSON.parse(response.data);

          this.notifications = Array.isArray(data.data) ? data.data : [];
          this.unreadCount = data.meta.totalCount || 0; // 알림 개수 갱신
        }
      } catch (error) {
        console.error("Error fetching alarm notifications:", error);
      }
    },
    async markAsRead(notificationId) {
      try {
        await this.$axios.post(
          `/api/notifications/${notificationId}/mark-as-read`
        );
        this.notifications = this.notifications.map((notification) =>
          notification.id === notificationId
            ? { ...notification, read: true }
            : notification
        );
        this.unreadCount -= 1;
      } catch (error) {
        console.error(
          "알림을 읽음으로 표시하는 중 오류가 발생했습니다:",
          error
        );
      }
    },
    handleLogoClick() {
      let menuMode = this.userType === 'M' ? 'M' : 'C'
      this.$store.commit('setSelectedMenu', '공지사항');
      this.$store.commit('setSelectedMenuId', this.findTopMenuId(this.$store.state.allMenus, menuMode, '공지사항'));

      if (this.$store.state.menuMode === 'C' && this.userType === 'M')
        this.changeMode();
      
      if (this.userType === 'M') {
        this.$router.replace({ path: "/temp-route" }).then(() => {
          this.$router.push({ path: "/mizenotices/list" });
        });
      }        
      else {
        this.$router.replace({ path: "/temp-route" }).then(() => {
          this.$router.push({ path: "/notices/list" });
        });
      }
    },
    checkAuth() {
      const token_userid = localStorage.getItem("userid");

      if (!token_userid) {
        this.$router.push({ path: "/" });
      } else if (this.$route.path === "/") {
        this.$router.push({ path: "/myinfo/view" });
      }
    },
    logout() {
      if (confirm("로그아웃 하시겠습니까?")) {
        this.toast.success("로그아웃 되었습니다.", {
          position: "top-center", // 메시지 위치
          timeout: 1500, // 3초 동안 표시
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true, // 진행 표시줄 숨기기
          closeButton: false, // X 버튼 숨기기
        });
        localStorage.clear();
        this.$store.dispatch("updateUserName", ""); // Vuex 스토어에서 사용자 이름 제거
        this.$store.dispatch("updateUserType", ""); // Vuex 스토어에서 사용자 이름 제거
        this.$store.dispatch("updateUsermodeauthority", ""); // Vuex 스토어와 localStorage에 저장
        this.$store.commit('setMenuMode', '');
        this.$store.commit('setRefreshFlag', false);        
        this.$store.commit('setSelectedMenu', '');
        this.$store.commit('setAllMenus', '');
        this.$store.commit('setTopMenus', []);
        this.$store.commit('setLeftMenus', []);
        this.$router.push({ path: "/" });
      }
    },
    selectMyInfo() {  
      this.$store.commit('setSelectedMenu', '내 정보');
      this.$store.commit('setSelectedMenuId', 0);

      if (this.$route.fullPath === '/myinfo/view') {
        this.$router.replace({ path: "/temp-route" }).then(() => {
          this.$router.replace('/myinfo/view');
        });
      }
    },
  },
};
</script>

<style scoped>
/* 필요한 스타일 정의 */
.logo img {
  cursor: pointer; /* 클릭 가능한 커서 모양 추가 */
  filter: none; /* 불필요한 필터 제거 */
  opacity: 1; /* 투명도 유지 */
}
.notification-container {
  position: relative;
  display: inline-block;
  margin-left: 15px;
  cursor: pointer;
}
.notification-container img {
  width: 24px;
  height: 24px;
}
.notification-badge {
  position: absolute;
  top: -5px;
  right: -10px;
  background-color: red;
  color: white;
  border-radius: 50%;
  font-size: 12px;
  padding: 2px 6px;
}
.notification-dropdown {
  position: absolute;
  right: 0;
  top: 50px;
  width: 300px;
  background-color: #ffffff; /* 배경색 */
  border: 1px solid #ddd;
  border-radius: 5px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  color: #333; /* 텍스트 색상 */
}
.notification-dropdown ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.notification-dropdown li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  background-color: #ffffff; /* 기본 배경색 */
  color: #333; /* 기본 텍스트 색상 */
}

.notification-dropdown li:hover {
  background-color: #f9f9f9; /* hover 시 배경색 */
  color: #000; /* hover 시 텍스트 색상 */
}

.notification-item {
  flex-grow: 1; /* 내용 영역 확장 */
}
.notification-image img {
  width: 40px;
  height: 40px;
  border-radius: 50%; /* 원형 이미지 */
  object-fit: cover; /* 이미지 크기 맞춤 */
}

.notification-content {
  flex-grow: 1;
}

.remove-btn {
  background-color: transparent;
  border: none;
  color: #ff0000;
  font-size: 16px;
  cursor: pointer;
}

.remove-btn:hover {
  color: #cc0000;
}

.notification-user {
  font-weight: bold; /* 사용자 이름 강조 */
  margin-right: 5px;
}

.view-all {
  display: block;
  text-align: center;
  padding: 10px;
  background: #0692e7;
  color: white;
  text-decoration: none;
}
.view-all:hover {
  background: #0692e7;
}
.no-notifications {
  padding: 20px;
  text-align: center;
  color: #555;
  font-size: 14px;
}

.disabled-notification {
  background-color: #f0f0f0; /* 회색 배경 */
  color: #a0a0a0; /* 희미한 텍스트 색상 */
  pointer-events: none; /* 클릭 비활성화 */
  cursor: not-allowed; /* 클릭 금지 커서 */
}

.notification-content .notification-user {
  font-weight: bold;
  color: inherit; /* 부모 색상 상속 */
}
</style>
